import React, { FC } from 'react';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';
import { useTranslation } from 'react-i18next';
import { Alert, Box, Button } from '@mui/material';

type ConfirmationDialogProps = {
    open: boolean;
    handleClose: () => void;
    handleOk: () => void;
    title: string;
    confirm: string;
    process: string;
    deleteInfoText?: string;
};

const ConfirmationDialog: FC<ConfirmationDialogProps> = ({
    open,
    handleOk,
    handleClose,
    title,
    confirm,
    process,
    deleteInfoText,
}: ConfirmationDialogProps) => {
    const { t: translate } = useTranslation(['common']);
    return (
        <DHDialog
            open={open}
            onClose={handleClose}
            title={title}
            actions={
                <>
                    <Button onClick={handleClose}>
                        {translate('common:NO')}, {translate('common:CANCEL')}
                    </Button>
                    <Button onClick={handleOk} autoFocus>
                        {translate('common:YES')}, {process}
                    </Button>
                </>
            }
        >
            {deleteInfoText ? (
                <Alert severity="info" sx={{ whiteSpace: 'pre-wrap', mb: 2 }}>
                    {deleteInfoText}
                </Alert>
            ) : undefined}
            <Box>{confirm}</Box>
        </DHDialog>
    );
};

export default ConfirmationDialog;
